
import { Component, Vue } from "vue-property-decorator";
import { Getter } from 'vuex-class';
import SendSmsCode from "@/components/SendSmsCode/index.vue";
import { changeMobileConfirm, bindMobile } from "@/api/my";
import { validatePhoneNumber, handleLogout } from "@/utils/util";
import { encryptData } from "@/utils/encryptData";

@Component({
  components: { SendSmsCode }
})
export class ChangeMobile extends Vue {
  @Getter mobile!: string

  isStep1 = true // 第1步：请先完成原手机号码验证 第2步：新手机号码验证
  // 第1步
  mobile1 = ''
  smsCode1 = ''
  businessId1 = ''
  isMobile1Err = false
  isSmsCode1Err = false
  // 第2步
  mobile2 = ''
  smsCode2 = ''
  businessId2 = ''
  isMobile2Err = false
  isSmsCode2Err = false
  errShakeClass = 'animate__animated animate__headShake'
  mobileErrMsg = '请输入正确的手机号码格式'

  mounted () {
    this.mobile1 = this.mobile
  }

  // 第1步
  onMobile1Focus () {
    this.isMobile1Err = false
  }

  onMobile1Blur (value: string) {
    if (value) {
      this.isMobile1Err = !validatePhoneNumber(value)
      this.mobileErrMsg = '请输入正确的手机号码格式'
    }
  }

  onSmsCode1Input () {
    this.isSmsCode1Err && (this.isSmsCode1Err = false)
  }

  onSendSmsCodeApiRes1 (res: any) {
    if (res.code === "000000") {
      this.businessId1 = res.data.businessId
    } else {
      this.mobileErrMsg = res.data.msg
      this.isMobile1Err = true
    }
  }

  onNext () {
    this.isSmsCode1Err && (this.isSmsCode1Err = false)
    if (!this.businessId1) {
      this.$toast("请先获取验证码");
      return
    }
    const params = {
      businessId: this.businessId1,
      mobile: encryptData(this.mobile1),
      smsCode: this.smsCode1
    }
    changeMobileConfirm(params).then(() => {
      this.isStep1 = false
    }).catch((err) => {
      const { code, msg = '请联系管理员' } = err.data || null
      if (code === '000001') {
        if (msg.includes('验证码')) { // 验证码有误（红字提示即可）
          this.isSmsCode1Err = true
        } else { // 其他错误（toast提示）
          this.$toast(msg)
        }
      }
    })
  }

  // 第2步
  onMobile2Focus () {
    this.isMobile2Err = false
  }

  onMobile2Blur (value: string) {
    if (value) {
      this.isMobile2Err = !validatePhoneNumber(value)
      this.mobileErrMsg = '请输入正确的手机号码格式'
    }
  }

  onSmsCode2Input () {
    this.isSmsCode2Err && (this.isSmsCode2Err = false)
  }

  onSendSmsCodeApiRes2 (res: any) {
    if (res.code === "000000") {
      this.businessId2 = res.data.businessId
    } else {
      this.mobileErrMsg = res.data.msg
      this.isMobile2Err = true
    }
  }

  onSubmit () {
    this.isSmsCode2Err && (this.isSmsCode2Err = false)
    if (!this.businessId2) {
      this.$toast("请先获取验证码");
      return
    }
    const params = {
      businessId: this.businessId2,
      mobile: encryptData(this.mobile2),
      oldMobile: encryptData(this.mobile1),
      smsCode: this.smsCode2
    }
    bindMobile(params).then(() => {
      this.$toast("修改成功");
      // 退出登录
      handleLogout()
    }).catch((err) => {
      const { code, msg = '请联系管理员' } = err.data || null
      if (code === '000001') {
        if (msg.includes('验证码')) { // 验证码有误（红字提示即可）
          this.isSmsCode2Err = true
        } else { // 其他错误（toast提示）
          this.$toast(msg)
        }
      }
    })
  }
}
export default ChangeMobile
